










































import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins,
  Emit,
  Model
} from 'vue-property-decorator'
import CustomCategoryApi from '@/api/goods/customCategory/index'

interface formValidate {
  CategoryId: string
}
@Component
export default class CustomCategorySelect extends Vue {
  @Prop({
    type: Boolean,
    default: () => {
      return false
    }
  })
  show!: false

  showModal = false
  categoryOptions: any[] = []
  brandOptions: any[] = []

  formValidate: formValidate = {
    CategoryId: ''
  }
  ruleValidate: any = {
    CategoryId: [
      {
        required: false,
        type: 'string',
        message: '请选择商品分组',
        trigger: 'change'
      }
    ]
  }

  async mounted() {}

  @Watch('show')
  async modalShowChange(show) {
    this.showModal = !this.showModal
    if (this.showModal) {
      await this.getCategoriesAll()
    }
  }

  resetData() {
    this.showModal = false
    this.formValidate = {
      CategoryId: ''
    }
  }

  cancelFn() {
    this.resetData()
    this.$emit('on-cancel', {
      CategoryId: this.formValidate.CategoryId,
      Title: ''
    })
  }

  ok() {
    this.$emit('on-ok', {
      CategoryId: this.formValidate.CategoryId,
      Title: this.categoryOptions.find(x=>x.id==this.formValidate.CategoryId).name
    })
    this.resetData()
  }

  async getCategoriesAll() {
    await CustomCategoryApi.getAll().then(res => {
      if (res.data) {
        this.categoryOptions = res.data.items
      }
    })
  }
}
